import React, { useRef } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Icon, useHovered, useResponsive, webOnlyStyles } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ReorderRailSeeAll = () => {
  const { minWidth } = useResponsive();
  const { formatMessage } = useIntl();

  // ─── Refs ────────────────────────────────────────────────────────────

  const ref = useRef(null);
  const isHovered = useHovered(ref);

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [
    styles.container,
    containerWebStyles,
    isHovered ? styles.containerHovered : undefined,
  ];

  // ─────────────────────────────────────────────────────────────────────

  if (minWidth.isSM) {
    return (
      <View ref={ref} style={containerStyles}>
        <BodyText sizeMatch={['18']} style={styles.label}>
          <FormattedMessage {...messages.seeAll} />
        </BodyText>
      </View>
    );
  }

  return (
    <View ref={ref} style={containerStyles} accessibilityLabel={formatMessage(messages.seeAll)}>
      <Icon name="IconArrowRight" color={theme.colors.DARK_KALE} />
    </View>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  seeAll: {
    defaultMessage: 'See all',
    description: 'Menu | Reorder rail | See all link',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  containerHovered: {
    opacity: 0.7,
  },
  label: {
    color: theme.colors.DARK_KALE,
    lineHeight: 18,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.DARK_KALE,
  },
});

const containerWebStyles = webOnlyStyles({
  transition: `opacity ${theme.transitions.base}ms`,
});
